module.exports = __webpack_public_path__ + "img/paint-00.7d6d0081.png";